import script from "./RAAIRegionalBranches.vue?vue&type=script&setup=true&lang=js"
export * from "./RAAIRegionalBranches.vue?vue&type=script&setup=true&lang=js"

import "./RAAIRegionalBranches.vue?vue&type=style&index=0&id=4b8bd342&lang=scss"

const __exports__ = script;

export default __exports__